import { Modal, Button } from "semantic-ui-react";
import { useNotifySubscriberContactMethodDelete } from "../../../../../../hooks/useNotifySubscriberContactMethodDelete";
import { useToasts } from "react-toast-notifications";
import { buildIdentifierString } from "../../../../subscribers/utils/buildIdentifierString";
import { FocusScope } from "react-aria";

export function DeleteSubscriberContactMethodModal({
  data,
  onClose,
}: {
  data: { subscriberContactMethodId: number } | null;
  onClose: () => void;
}) {
  const { addToast } = useToasts();

  const { deleteSubscriberContactMethod, isDeleteSubscriberContactMethodLoading } =
    useNotifySubscriberContactMethodDelete({
      onSuccess(method) {
        addToast(`Removed ${buildIdentifierString(method)}`, {
          appearance: "success",
          autoDismiss: true,
        });
        onClose();
      },
    });

  return (
    <Modal open={!!data} onClose={onClose} size='tiny' closeIcon>
      <Modal.Header>Delete Contact Method?</Modal.Header>
      <FocusScope contain autoFocus restoreFocus>
        <Modal.Content>
          <p>
            Are you sure you want to delete this contact method? This action cannot be undone. You will no longer
            receive notifications through this method.
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={onClose}>
            Cancel
          </Button>
          <Button
            negative
            loading={isDeleteSubscriberContactMethodLoading}
            onClick={async () => {
              if (!data) return;
              await deleteSubscriberContactMethod(data.subscriberContactMethodId);
            }}
          >
            Delete
          </Button>
        </Modal.Actions>
      </FocusScope>
    </Modal>
  );
}
